import React from 'react';

class ProfileService extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            profileId: this.props.profileId
        };
    }

    componentDidMount = () => {}

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            profileId: nextProps.profileId
        });
    }

    render() {
        return (
            <div className="page_course_box profile_content_wrapper" id="root-linkedin">
                <div className="title_box">
                    <h2 className="t-20 t-black mb2">
                        Services provided
                    </h2>
                </div>
                <div className="body_box">
                    <ul className="profile-skills__skill-list profile-skills__skill-list-full">
                        <li className="profile-skills__skill">
                            <button role="checkbox" aria-checked="false"
                                    aria-label="Apache Kafka"
                                    className="artdeco-pill--slate artdeco-pill--toggle ember-view"
                                    type="button"><span
                                className="artdeco-pill__text">Career Development Coaching</span>
                            </button>
                        </li>
                        <li className="profile-skills__skill">  
                            <button role="checkbox" aria-checked="false"
                                    aria-label="Apache Kafka"
                                    className="artdeco-pill--slate artdeco-pill--toggle ember-view"
                                    type="button"><span
                                className="artdeco-pill__text">Executive Coaching</span>
                            </button>
                        </li>
                        <li className="profile-skills__skill">
                            <button role="checkbox" aria-checked="false"
                                    aria-label="Apache Kafka"
                                    className="artdeco-pill--slate artdeco-pill--toggle ember-view"
                                    type="button"><span
                                className="artdeco-pill__text">Interview Preparation</span>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
        )
    }
}

export default ProfileService;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/profile/profile_service.js
 **/